module.exports = __webpack_public_path__ + "img/gwnu_main0.82700d94.jpg";